import React, { useEffect, useState } from "react";
import { settingService } from "../../../services/extensions";
import { PickList } from "primereact/picklist";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { Toolbar } from "primereact/toolbar";
import { useSelector } from 'react-redux';
import { selectUser } from '../../../services/store/userSlice';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { template } from "lodash";

function CategoryMapping() {
  const user = useSelector(selectUser);
  const empIndex = user.roles.indexOf('Masters Admin', 'Users Admin', 'ADMIN');
  const [projects, setProjects] = useState([]);
  const [masterCategory, setMasterCategory] = useState([]);
  const [filterMasterCategory, setFilterMasterCategory] = useState([]);
  const [category, setCategory] = useState([]);
  const [selProject, setSelProject] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [inputValue, setInputValue] = useState('');

  let count = 0;
  useEffect(() => {
    // getProjects();
    if (count === 0) {
      getProjectsByUser();
      getMasterCategory();
      count++;
    }
  }, []);

  const filterProject = (data) => {
    settingService.getCategoriesByProjectId(data.id).then((resp) => {
      setAllCategory(resp.data.data);
      setSelProject(data);
      //   let projectFilter = resp.data.data.filter((item) => {
      //     return (
      //       item.projectId === data.id &&
      //       item.userId === null &&
      //       item.status !== 4
      //     );
      //   });
      const restMasterArray = filterMasterCategory.filter(
        ({ title: id1 }) =>
          !resp.data.data.some(({ title: id2 }) => id2 === id1)
      );
      setMasterCategory(restMasterArray);
      setCategory(resp.data.data);
    });
  };

  // const itemBody = (item) => {
  //   console.log(item, "itemitemitem", selectedType)
  //   return (<><span>{item.title}</span> <InputText /></>);
  // };
  const getProjectsByUser = () => {
    if (empIndex === 1) {
      settingService.getProjects().then(resp => {
        setProjects(resp.data.data);
      });
    } else {
      settingService.getProjectsByUser().then((resp) => {
        setProjects(resp.data.data);
      });
    }
  };

  const getMasterCategory = () => {
    settingService.getAllMasterCategory().then((resp) => {
      setMasterCategory(resp.data.data);
      setFilterMasterCategory(resp.data.data);
    });
  };

  const onChange = (event) => {
    if (selProject.length === 0) {
      toast.error("Please select Project!");
      return 1;
    }
    // moving all element source to target
    if (event.source.length === 0 && event.target.length !== 0) {
      var selectedSource = [];
      event.target.map((item) => {
        if (!item.projectId) {
          selectedSource.push(item);
        }
      });
      var proListing = [];
      selectedSource.map((item) => {
        let objProject = {
          projectId: selProject.id,
          code: item.code,
          title: item.title,
        };
        proListing.push(objProject);
      });
      let param = proListing;
      settingService.addCategoryInBulk(param).then((resp) => {
        setMasterCategory(event.source);
        setCategory(event.target);
        filterProject(selProject);
      });
      return true;
    }

    if (event.target.length === 0 && event.source.length !== 0) {
      settingService.deleteCategoryByProjectId(selProject.id).then((resp) => {
        setMasterCategory(event.source);
        setCategory(event.target);
        filterProject(selProject);
      });
      return true;
    }

    if (selProject.length != 0) {
      if (selectedType === "source") {
        // Add Category
        var proListing = [];
        selectedRowData.map((item) => {
          let objProject = {
            projectId: selProject.id,
            code: item.code,
            title: item.title,
          };
          proListing.push(objProject);
        });
        let param = proListing;
        settingService.addCategoryInBulk(param).then((resp) => {
          setMasterCategory(event.source);
          setCategory(event.target);
          filterProject(selProject);
        });
      }

      if (selectedType === "target") {
        let id = selectedRowData[0].id;
        settingService.deleteCategoryById(id).then((resp) => {
          setMasterCategory(event.source);
          setCategory(event.target);
          filterProject(selProject);
        });
      }
    }
  };

  const onSourceSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("source");
  };
  const onTargetSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("target");
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div>
          <h3>Select Project</h3>
          <Dropdown
            filter
            id="project_list"
            name="project_list"
            options={projects}
            value={selProject}
            onChange={(e) => filterProject(e.value)}
            optionLabel="title"
            placeholder="Select Project"
            style={{ minWidth: "180px" }}
          />
        </div>
      </React.Fragment>
    );
  };

  const sourceTemplate = (item) => {
    return <span>{item.title}</span>;
  };

  const editTargetCategory = (itemId) => {
    setInputValue("");
    setEditItemId(itemId);
  }

  const saveTargetCategory = (itemToSave) => {
    console.log(inputValue, "inputValueinputValue")
    if(inputValue < 1){
      toast.error("Value should be grater than equal to 1");
    } else {
      let param = {
        id: itemToSave.id,
        "projectId": itemToSave.projectId,
        "userId": itemToSave.userId,
        "code": itemToSave.code,
        "rate": inputValue,
        "title": itemToSave.title
      }
      settingService.updateCategoryRate(param).then((resp) => {
        if (resp) {
          filterProject(selProject);
          setEditItemId(null);
        }
      });
    }
    

  }
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const targetTemplate = (item) => {
    return (
      <div id={`updateCatRate_${item.id}`}>
        <span>{item.title}</span>
        {editItemId === item.id && (
          <>
            <InputText name={`updateCatRate_${item.id}`} id={`updateCatRate_${item.id}`} style={{ width: '50px', borderRadius: '6px' }} value={inputValue} onChange={handleChange} className="ml-7" />
            <Button icon="pi pi-check" className="ml-2" rounded aria-label="Target" onClick={(e) => saveTargetCategory(item)} />
          </>
        )}
        {editItemId !== item.id && (
          <>
            <InputText style={{ width: '50px', borderRadius: '6px' }} className="ml-7" value={item.rate} disabled />
            <Button icon="pi pi-pencil" className="ml-2" rounded aria-label="Target" onClick={(e) => editTargetCategory(item.id)} />
          </>
        )}
      </div>
    );
  };


  return (
    <React.Fragment>
      <div>
        <Toolbar
          className="mb-2"
          left=""
          right={rightToolbarTemplate}
        ></Toolbar>
      </div>
      <PickList
        source={masterCategory}
        target={category}
        // itemTemplate={itemBody}
        sourceItemTemplate={sourceTemplate}
        targetItemTemplate={targetTemplate}
        sourceHeader="Master Category"
        targetHeader="Project Category"
        sourceStyle={{ height: "23.6vw" }}
        targetStyle={{ height: "23.6vw" }}
        onChange={onChange}
        onSourceSelectionChange={(e) => onSourceSelectionChange(e)}
        onTargetSelectionChange={(e) => onTargetSelectionChange(e)}
        // onMoveAllToSource={(e) => onMoveAllToSource(e)}
        // onMoveAllToTarget={(e) => onMoveAllToTarget(e)}
        className="col-8 col-offset-2"
        // style={{ marginLeft: "13vw" }}
        showSourceControls={false}
        showTargetControls={false}
      />
    </React.Fragment>
  );
}

export default CategoryMapping;
